import { useStaticCrud } from 'legacy/lut/hooks/useStaticCrud'
import { useEffect, useMemo } from 'react'

import { uniqueBy } from 'clickNgo/helpers/array'
import { useSafetyTranslation } from 'cng-common/features/translations/hooks'
import { MultiSelectDynamic } from 'core-components/library/multiSelect'

import type { IFinancialCockpitUserWithScope } from '../../api/types'

interface ICockpitUserSelectProps {
  value: string[]
  onChange: (emails: string[]) => void
  users: IFinancialCockpitUserWithScope[]
  placeholderKey: string
  sortByName?: boolean
}

const FULL_NAME_SORT = { field: 'FullName', dir: 'asc' } as const

export const CockpitUserSelect = ({
  value,
  onChange,
  users,
  placeholderKey,
  sortByName = false,
}: ICockpitUserSelectProps) => {
  const t = useSafetyTranslation()
  const uniqueUsers = useMemo(
    () =>
      uniqueBy(users, (user) => user.Email).map((user) => ({
        ...user,
        FullName: user.FullName || user.Email,
      })),
    [users]
  )

  const usersSource = useStaticCrud<IFinancialCockpitUserWithScope>({
    items: uniqueUsers,
    keyField: 'Email',
    sorting: sortByName ? FULL_NAME_SORT : undefined,
    // displayField: 'FullName',
  })

  useEffect(() => {
    const availableEmails = new Set(uniqueUsers.map(({ Email }) => Email))
    const validEmails = value.filter((email) => availableEmails.has(email))

    if (validEmails.length !== value.length) {
      onChange(validEmails)
    }
  }, [onChange, uniqueUsers, value])

  return (
    <MultiSelectDynamic
      source={usersSource}
      caption="FullName"
      value={value}
      onChange={onChange}
      placeholder={t(placeholderKey)}
      closeOnSelect={false}
    />
  )
}
